import Cookies from 'js-cookie';

const style = document.querySelector(`link#default-style-css`);
let rules = null;
const mqrules = [];

const config = {
  textIncrease: 'data-js-text-increase',
  textDecrease: 'data-js-text-decrease',
  contrast: 'data-js-contrast',
  zoomCookieSize: Cookies.get('text-zoom'),
  sizes: ['font-size-1', 'font-size-2', 'font-size-3'],
  zoomScales: [1.3, 1.6, 2],
};

function getMediaQueries() {
  try {
    rules = style.sheet.cssRules;
  } catch (err) {
    console.error(err);
    return;
  }

  if (rules) {
    [...rules].forEach((rule, i) => {
      if (rule.type === 4) {
        // type 4 are Media Queries
        mqrules.push([i, rule.media.mediaText]);
      }
    });
  }
}

function scaleMediaQueries(zoomLevel) {
  const scaleValue = zoomLevel
    ? config.zoomScales[config.sizes.indexOf(zoomLevel)]
    : 1;

  if (mqrules && scaleValue) {
    mqrules.forEach((mqrule) => {
      rules[mqrule[0]].media.mediaText = mqrule[1].replace(
        /(\d+(\.\d+)?)/g,
        (match, number) => number * scaleValue,
      );
    });
  }
}

/**
 * [removeDisabled Remove disabled classes from inputs]
 * @param  {[type]} btn [btn you want to remove disabled from]
 * @return {[undefined]} []
 */
function removeDisabled(btn) {
  btn.disabled = false;
  btn.classList.remove('disabled');
}

/**
 * [addDisabled Add disabled classes from inputs]
 * @param {[type]} btn [btn you want to add disabled to]
 * @return {[undefined]} []
 */
function addDisabled(btn) {
  btn.disabled = true;
  btn.classList.add('disabled');
}

/**
 * [contrast Toggle high contrast mode]
 * @return {[undefined]} []
 */
function contrast() {
  if (document.documentElement.classList.contains('high-contrast')) {
    Cookies.remove('high-contrast');
  } else {
    Cookies.set('high-contrast', true, { path: '/' });
  }

  document.documentElement.classList.toggle('high-contrast');
}

/**
 * [setBaseFontSize Set base font size. Also used to reset sizes & btn states]
 * @return {[undefined]} []
 */
function setBaseFontSize() {
  // Disable or enable controls, if cookie

  if (config.zoomCookieSize !== undefined) {
    // Disable zoom if already at 200%

    document.documentElement.setAttribute(
      'data-font-size',
      config.zoomCookieSize,
    );
    scaleMediaQueries(config.zoomCookieSize);

    if (config.zoomCookieSize === config.sizes[config.sizes.length - 1]) {
      addDisabled(document.querySelector(`[${config.textIncrease}]`));
    }
  } else {
    removeDisabled(document.querySelector(`[${config.textIncrease}]`));
    addDisabled(document.querySelector(`[${config.textDecrease}]`));
  }
}

/**
 * [zoomIn Increase base font size]
 * @return {[undefined]} []
 */
function zoomIn() {
  let currentSize = 0;
  let currentSizeIndex;

  // Get current size from html
  currentSize = document.documentElement.getAttribute('data-font-size');
  currentSizeIndex = config.sizes.indexOf(currentSize);

  currentSizeIndex += 1;

  // Increase site fonts to 200% of base size
  if (currentSizeIndex < config.sizes.length) {
    document.documentElement.setAttribute(
      'data-font-size',
      config.sizes[currentSizeIndex],
    );
    scaleMediaQueries(config.sizes[currentSizeIndex]);
    removeDisabled(document.querySelector(`[${config.textIncrease}]`));
    removeDisabled(document.querySelector(`[${config.textDecrease}]`));
    Cookies.set('text-zoom', config.sizes[currentSizeIndex], { path: '/' });
  }

  if (
    parseInt(currentSizeIndex, 10) + 1 ===
    parseInt(config.sizes.length, 10)
  ) {
    addDisabled(document.querySelector(`[${config.textIncrease}]`));
  }
}

/**
 * [zoomOut Decrease base font size]
 * @return {[undefined]} []
 */
function zoomOut() {
  const currentSize = document.documentElement.getAttribute('data-font-size');
  let currentSizeIndex = config.sizes.indexOf(currentSize);

  currentSizeIndex -= 1;

  if (typeof config.sizes[currentSizeIndex] !== 'undefined') {
    document.documentElement.setAttribute(
      'data-font-size',
      config.sizes[currentSizeIndex],
    );
    scaleMediaQueries(config.sizes[currentSizeIndex]);
    Cookies.set('text-zoom', config.sizes[currentSizeIndex], { path: '/' });

    // Enable zoom btn
    removeDisabled(document.querySelector(`[${config.textIncrease}]`));
  } else {
    Cookies.remove('text-zoom');
    document.documentElement.removeAttribute('data-font-size');
    scaleMediaQueries();
    addDisabled(document.querySelector(`[${config.textDecrease}]`));
  }
}

function events() {
  const queryAllIncrease = document.querySelectorAll(
    `[${config.textIncrease}]`,
  );
  const queryAllDecrease = document.querySelectorAll(
    `[${config.textDecrease}]`,
  );
  const queryAllContrast = document.querySelectorAll(`[${config.contrast}]`);

  for (let i = 0; i < queryAllIncrease.length; i += 1) {
    queryAllIncrease[i].addEventListener('click', zoomIn);
  }

  for (let i = 0; i < queryAllIncrease.length; i += 1) {
    queryAllDecrease[i].addEventListener('click', zoomOut);
  }

  for (let i = 0; i < queryAllIncrease.length; i += 1) {
    queryAllContrast[i].addEventListener('click', contrast);
  }
}

export function init() {
  if (document.querySelector('.accessibility-controls')) {
    events();
    getMediaQueries();
    setBaseFontSize();

    if (Cookies.get('high-contrast')) {
      document.documentElement.classList.add('high-contrast');
    }
  }
}
